let Barba = require('barba.js');
import Swiper from 'swiper/dist/js/swiper';
// import SearchBar from "widgets/search-bar/widget";

module.exports = Barba.BaseView.extend({
    namespace: 'main-page',

    onEnter: function () {

        // let searchBar = new SearchBar();

        // // замена картинок на главной при 375 - 768
        // var w = $(window).width();
        // $(window).resize(function () {
        //     var new_w = $(window).width();

        //     if (new_w <= 767 && new_w >= 374) {
        //         w = new_w;
        //         $('.main__block-img_one').attr('src', '/src/images/main-img-1-1024.jpg');
        //         $('.main__block-img_two').attr('src', '/src/images/main-img-2-1024.jpg');
        //         $('.main__block-img_three').attr('src', '/src/images/main-img-3-1024.jpg');
        //     }
        //     else {
        //         $('.main__block-img_one').attr('src', '/src/images/main-img-3.jpg');
        //         $('.main__block-img_two').attr('src', '/src/images/main-img-3.jpg');
        //         $('.main__block-img_three').attr('src', '/src/images/main-img-3.jpg');
        //     }

        // });
        // if (w <= 767 && w >= 374) {
        //     $('.main__block-img_one').attr('src', '/src/images/main-img-1-1024.jpg');
        //     $('.main__block-img_two').attr('src', '/src/images/main-img-2-1024.jpg');
        //     $('.main__block-img_three').attr('src', '/src/images/main-img-3-1024.jpg');
        // }
        // else {
        //     $('.main__block-img_one').attr('src', '/src/images/main-img-3.jpg');
        //     $('.main__block-img_two').attr('src', '/src/images/main-img-3.jpg');
        //     $('.main__block-img_three').attr('src', '/src/images/main-img-3.jpg');
        // }

        new Swiper('.slider__holder', {
            speed: 400,
            loop: true,
            navigation: {
                nextEl: '.slider__arrow_right',
                prevEl: '.slider__arrow_left',
            },
            pagination: {
                el: '.slider__pagination',
                type: 'bullets',
                bulletClass: 'slider__pagination-dot',
                bulletActiveClass: 'slider__pagination-dot_active',
                clickable: true,
            },
            autoplay: {
                delay: 4000,
            },
        });

        if ($(window).width() < 768) {
            new Swiper('.main__about-instagram-row', {
                speed: 400,
                loop: true,
                spaceBetween: 15,
                slidesPerView: 'auto',
                navigation: {
                    prevEl: '.main__about-instagram-arrow_left',
                    nextEl: '.main__about-instagram-arrow_right',
                },
                // autoplay: {
                //     delay: 4000,
                // },
            });
        } 

    },

    onLeave: function () {

    }
});



// WEBPACK FOOTER //
// resources/assets/src/js/views/main-page.js